import { render, staticRenderFns } from "./PointListTop.vue?vue&type=template&id=9fbdd184&"
import script from "./PointListTop.vue?vue&type=script&lang=js&"
export * from "./PointListTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports